const config = {
    build_number: '616905',
    build_timestamp: '2026-10-13T19:02:29.125Z',
    build_commit: '8541f60ded0f8ce81409cd1bb3ffcd1d24fb7593',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
